package meineglasfaser.frontend.admin.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.navigation.Anchor
import meineglasfaser.api.AdminUserRole
import meineglasfaser.frontend.admin.components.LocalAdminUserState
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun LandingPage(ctx: PageContext) {
    val baseInfo = LocalAdminUserState.current.baseInfoOrNull()
    Div {
        H1 { Text("Prometheus Network") }
        P { Text("Erleben Sie die Zukunft der Internetverbindung mit unserer schnellen und zuverlässigen Glasfaser-Technologie.") }
        if (baseInfo != null && baseInfo.roles.contains(AdminUserRole.EXTERNAL_LAHO)) {
            Anchor("/external/laho", {
                role("button")
            }) {
                Text("Zum Lassnitzhöhe Tool")
            }
        }
    }
}
